module.exports = __webpack_public_path__ + "static/media/tpn-ce-wire-3.3d44f91b.png";